<ion-card
  mode="ios"
  color="transparent"
  class="card-top-image-detail"
  [ngClass]="{ 'card-promo-detail': isPromo }"
>
  <!-- ! Fila superior: Tags -->
  <ion-item mode="ios" lines="none" color="transparent" class="item-top-tags">
    <!-- * TAG Exclusivo -->
    <section>
      <ng-container *ngIf="soloApp">
        <getm-tag-card-product
          [label]="'Labels.only-app' | translate"
          [color]="'getm-primary-default'"
          corners="br"
          fill="solid"
        ></getm-tag-card-product>
      </ng-container>
    </section>

    <!-- * TAG Recomendador -->
    <section slot="end" class="tag-recommender">
      <ng-container *ngIf="recommender !== 0">
        <getm-tag-card-product
          [icon]="segment.icon"
          [label]="segment.title"
          [color]="segment.color"
          [fill]="recommenderFill"
          corners="bl"
        ></getm-tag-card-product>
      </ng-container>
    </section>
  </ion-item>

  <!-- ! Fila central / Contenido para Producto -->
  <ng-container *ngIf="!isPromo; else promoContentTemplate">
    <ion-item
      mode="ios"
      lines="none"
      color="transparent"
      class="item-center-content"
    >
      <!-- Iconos a la izquierda en columna vertical -->
      <section
        slot="start"
        *ngIf="badges && badges.length > 0"
        class="container-badges"
      >
        <ng-container *ngFor="let badge of badges; let i = index">
          <getm-tag-card-img
            [icon]="badge.icon"
            [iconColor]="badge.iconColor || 'contrast'"
            [slotIcon]="badge.slotIcon || 'left'"
            [label]="badge.label"
            [shape]="badge.shape || 'squared'"
            [color]="badge.color || 'primary'"
            [size]="badge.size || 'medium'"
            [fill]="badge.fill || 'solid'"
            (tagClick)="onBadgeClick(i)"
          ></getm-tag-card-img>
        </ng-container>
      </section>

      <!-- Imagen central Producto -->
      <ion-thumbnail class="thumbnail-product-img">
        <ion-img [src]="imagen"></ion-img>
      </ion-thumbnail>

      <!-- Icono de zoom a la derecha -->
      <section slot="end" *ngIf="canShowZoom()" class="container-zoom">
        <getm-tag-card-img
          [icon]="zoomIcon"
          size="x-large"
          iconColor="getm-neutral-dark"
          color="getm-neutral-white"
          (tagClick)="onZoomClick()"
        ></getm-tag-card-img>
      </section>
    </ion-item>
  </ng-container>

  <!-- ! Template Contenido para Promo -->
  <ng-template #promoContentTemplate>
    <section class="promo-image-container">
      <ion-icon
        [name]="isBonificacion ? 'getm-gift-fill' : 'getm-discount-fill'"
        color="getm-neutral-hover"
        class="bg-icon"
      ></ion-icon>
      <ng-container *ngIf="imagen; else marcasPromoTemplate">
        <ion-img [src]="imagen" class="img-promo" />
      </ng-container>

      <ng-template #marcasPromoTemplate>
        <section class="brands-wrapper">
          <ion-row
            class="row-content-brands ion-align-items-center ion-justify-content-center"
            *ngIf="marcas && marcas.length > 0"
          >
            <ng-container
              *ngFor="
                let marca of marcas | slice : 0 : 6;
                trackBy: trackByMarca;
                let i = index;
                last as isLast
              "
            >
              <ion-col
                [size]="marcas.length < 5 ? 3 : 4"
                class="ion-no-padding"
              >
                <ng-container
                  *ngIf="marcas.length > 6 && isLast; else imagesBrands"
                >
                  <ion-thumbnail class="thumbnail-brand-more">
                    <ion-icon
                      name="ellipsis-horizontal"
                      color="getm-category-especiales-del-mes"
                    ></ion-icon>
                  </ion-thumbnail>
                </ng-container>
                <ng-template #imagesBrands>
                  <ion-thumbnail
                    class="thumbnail-brand"
                    [ngStyle]="{
                      '--size':
                        marcas.length < 2
                          ? '64px'
                          : marcas.length < 3
                          ? '55px'
                          : marcas.length < 5
                          ? '40px'
                          : '32px'
                    }"
                  >
                    <ion-img [src]="marca.URL_Imagen" [alt]="marca.Marca" />
                  </ion-thumbnail>
                </ng-template>
              </ion-col>
            </ng-container>
          </ion-row>
        </section>
      </ng-template>

      <!-- Icono de zoom flotante para promo -->
      <section *ngIf="canShowZoom()" class="container-zoom">
        <getm-tag-card-img
          [icon]="zoomIcon"
          size="x-large"
          iconColor="getm-neutral-dark"
          color="getm-neutral-white"
          (tagClick)="onZoomClick()"
        ></getm-tag-card-img>
      </section>
    </section>
  </ng-template>
</ion-card>
